import React, { FC, PropsWithChildren } from 'react';
import { View } from 'react-native';
import Buttons from '@styles/buttons';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';
import { ContainerStyle, SimpleOnPress } from '@interfaces/base';

export interface ActionButtonProps extends PropsWithChildren, ContainerStyle,  SimpleOnPress {
  testID?: string;
}

const ActionButton: FC<ActionButtonProps> = ({ children, onPress, containerStyle, testID }) => {
  const { scale, font } = useOperatorPanelSettingsWrapperContext();

  return (
    <View
      style={[{transform: [{translateY: scale(1)}]}, containerStyle]}
    >
      <Buttons {...{ variant: 'M', type: 'Secondary', onPress, font, scale, testID }}>{children}</Buttons>
    </View>
  );
};

export default ActionButton;
